import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Component, ContextType, DropInPaymentsCommandNames, fireLogEvent, fireStatusUpdate, getMopError, Namespace, PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import { getForterTokenCookie } from '@chegg/utils';
import { CheggBaseUrlProduction, ORDER_SUCCESS, PLACE_ORDER_ATTEMPTED } from '../../constants/AppConstants';
import { CheckoutErrors } from '../../constants/CheckoutErrors';
import { ERRORS } from '../../constants/Errors';
import { saveCartInfo } from '../../redux/cart/cart.slice';
import { showMessage } from '../../redux/message/message.slice';
import { MessageType } from '../../redux/message/message.types';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import BaseCommand from './BaseCommand';
import { getCheckoutTypeAnnotation } from '../../utils/CheckoutTypeAnnotationUtil';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { saveUpiMop } from '../../redux/upiMop/upiMop.slice';
import { saveUiConfigs } from '../../redux/config/config.slice';

//NOTE: This command is called by PaymentMethods internally.
//This is NOT to be called by a host app.
var ORDER_PLACEMENT_FAILED = 'Order placement failed';
export var InitializeUpiCheckoutCommand = /*#__PURE__*/function (_BaseCommand) {
  function InitializeUpiCheckoutCommand(params) {
    _classCallCheck(this, InitializeUpiCheckoutCommand);
    return _callSuper(this, InitializeUpiCheckoutCommand, [params]);
  }
  _inherits(InitializeUpiCheckoutCommand, _BaseCommand);
  return _createClass(InitializeUpiCheckoutCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _forterToken, _response$data$orderK, _response$data;
        var _this$state, _this$state$config, useForter, userAction, token, externalId, validProductType, _this$input$data, mop, deviceData, accountType, type, forterToken, response, _ref, paymentProcessor;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.informHostOrderPending();
              _this$state = this.state, _this$state$config = _this$state.config, useForter = _this$state$config.useForter, userAction = _this$state$config.userAction, token = _this$state.fraud.forterToken, externalId = _this$state.cart.externalId;
              validProductType = this.getValidProductType(this.state.cart, userAction);
              if (validProductType) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _this$input$data = this.input.data, mop = _this$input$data.mop, deviceData = _this$input$data.deviceData;
              accountType = mop.accountType, type = mop.type;
              forterToken = undefined;
              if (useForter || useForter === undefined) {
                forterToken = token || getForterTokenCookie();
              }
              this.dispatch(saveUpiMop(mop));
              _context.next = 12;
              return this.client.checkoutAPI.submitInitiateCheckout(this.preparePlaceOrderInput({
                deviceData: deviceData,
                forterToken: forterToken,
                validProductType: validProductType,
                action: userAction,
                fetchMopPayload: mop,
                cart: this.state.cart,
                placeOrderAnnotations: this.state.config.placeOrderAnnotations
              }), this.state.cart.cartId, CheggBaseUrlProduction);
            case 12:
              response = _context.sent;
              sendNewRelicMessage(PLACE_ORDER_ATTEMPTED, {
                productType: validProductType,
                externalId: externalId !== null && externalId !== void 0 ? externalId : '',
                fraudVendorData: (_forterToken = forterToken) !== null && _forterToken !== void 0 ? _forterToken : '',
                hasErrors: Boolean(this.hasErrors(response.errors)).toString(),
                orderKey: (_response$data$orderK = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.orderKey) !== null && _response$data$orderK !== void 0 ? _response$data$orderK : '',
                accountType: accountType,
                cardType: type !== null && type !== void 0 ? type : ''
              });
              if (!this.hasErrors(response.errors)) {
                _ref = response.data, paymentProcessor = _ref.paymentProcessor;
                this.dispatch(savePaymentMethodsCommands([{
                  commandName: PaymentMethodsCommandNames.OPEN_BILLDESK,
                  data: _objectSpread({}, paymentProcessor)
                }]));
              } else {
                if (response.errors[0].code === CheckoutErrors.ORDER_ALREADY_PLACED) {
                  this.sendOrderPlacedLog(true);
                }
                this.sendErrorsAndResetCheckoutState(response.errors);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
    /**
     * Send a log to NR to track that an order was placed.
     * @param orderAlreadyPlaced indicates if this order was already placed in the past but the order placed log was not fired.
     */
  }, {
    key: "sendOrderPlacedLog",
    value: function sendOrderPlacedLog(orderAlreadyPlaced) {
      var _this$state$cart = this.state.cart,
        items = _this$state$cart.items,
        externalId = _this$state$cart.externalId;
      var _this$input$data$mop = this.input.data.mop,
        type = _this$input$data$mop.type,
        accountType = _this$input$data$mop.accountType;
      var config = this.state.config;
      var couponCode = config.couponCode,
        coupon = config.coupon;
      var addCouponStatus = coupon.addCouponStatus;
      var appliedCoupon = addCouponStatus === 'SUCCESS' && couponCode && couponCode.length > 0 ? couponCode : null;
      var successObject = {
        productType: items[0].productType,
        externalId: externalId
      };

      /*
          If the order has already been placed then we cannot use data from our store as it
          could've changed since the original order was placed. E.G. if user creates a new MOP
          and tries again. ProductType and ExternalId will not change without a page refresh.
        */
      if (!orderAlreadyPlaced) {
        successObject['paymentMethod'] = accountType;
        if (type) successObject['cardType'] = type;
        if (appliedCoupon) successObject['couponCode'] = appliedCoupon;
      }
      sendNewRelicMessage(ORDER_SUCCESS, successObject);
    }
  }, {
    key: "informHostUpiOrderPending",
    value: function informHostUpiOrderPending(paymentProcessor) {
      fireStatusUpdate([{
        status: StatusTypes.PENDING,
        command: DropInPaymentsCommandNames.PLACE_ORDER,
        payload: {
          component: Component.PAYMENT_METHODS_CALLBACK,
          context: ContextType.DROP_IN_PAYMENTS,
          data: paymentProcessor
        }
      }], Namespace.DROP_IN_PAYMENTS);
    }
  }, {
    key: "informHostOrderPending",
    value: function informHostOrderPending() {
      if (!this.state.cart.isCheckoutPending) {
        fireStatusUpdate([{
          status: StatusTypes.PENDING,
          command: DropInPaymentsCommandNames.PLACE_ORDER,
          payload: {
            component: Component.PAYMENT_METHODS_CALLBACK,
            context: ContextType.DROP_IN_PAYMENTS
          }
        }], Namespace.DROP_IN_PAYMENTS);
      }
    }

    /**
     * Prepares a payload to call checkout on the API
     * @param params PreparePlaceOrderInput
     * @param fetchMopPayload Currently selected MOP in payment methods
     */
  }, {
    key: "preparePlaceOrderInput",
    value: function preparePlaceOrderInput(params) {
      var cart = params.cart,
        deviceData = params.deviceData,
        validProductType = params.validProductType,
        forterToken = params.forterToken,
        action = params.action,
        placeOrderAnnotations = params.placeOrderAnnotations,
        fetchMopPayload = params.fetchMopPayload;
      var cardId = fetchMopPayload.cardId,
        accountType = fetchMopPayload.accountType,
        type = fetchMopPayload.type,
        description = fetchMopPayload.description,
        last4 = fetchMopPayload.last4,
        month = fetchMopPayload.month,
        year = fetchMopPayload.year,
        paymentAccountType = fetchMopPayload.paymentAccountType;
      var checkoutType = getCheckoutTypeAnnotation(action);
      return {
        command: 'placeOrder',
        productType: validProductType,
        data: {
          billing: this.getBillingInformation(fetchMopPayload),
          payment: {
            cardId: cardId,
            // Missing interface was ts-ignored here: PaymentMethodsData doesn't have paymentAccountType
            // @chegg/payment-methods PaymentMethodsData (referenced from SDK)
            paymentAccountType: paymentAccountType,
            accountType: accountType,
            type: type,
            description: description,
            last4: last4,
            month: month,
            year: year
          },
          deviceData: deviceData,
          items: cart.items,
          doAdditionalAddressValidation: this.shouldPerformAdditionalAddressValidation(fetchMopPayload.billingAddress.country, fetchMopPayload.billingAddress.zip),
          hostAnnotations: _objectSpread(_objectSpread(_objectSpread({}, placeOrderAnnotations), checkoutType ? {
            checkoutType: checkoutType
          } : {}), {}, {
            fraudVendorData: "{\"forterToken\": \"".concat(forterToken, "\"}")
          })
        }
      };
    }

    //TODO: come back and sort out these mismatched types
  }, {
    key: "getBillingInformation",
    value: function getBillingInformation(fetchMopPayload) {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (fetchMopPayload.billingAddress) {
        return _objectSpread(_objectSpread({}, fetchMopPayload.billingAddress), {}, {
          qas_bypass: '',
          errors: false,
          key: ''
        });
      }
      return undefined;
    }

    //TODO: revisit this when implementing coupons
    /**
     * Gets a valid product type from cart. There should only be one digital item in cart but in future we
     * could potentially have coupons. We need to find the right productType from a mult-item cart.
     * @param cart cart to checkout.
     * @param userAction the users current action.
     * @returns Product type if exactly one valid, otherwise null.
     */
  }, {
    key: "getValidProductType",
    value: function getValidProductType(cart, userAction) {
      if (cart.items.length === 0) {
        this.sendErrorsAndResetCheckoutState([ERRORS.NO_ITEMS_IN_CART_FAILURE], JSON.stringify({
          cartId: cart.cartId,
          externalId: cart.externalId,
          userAction: userAction
        }));
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      var validItem = cart.items.find(function (item) {
        return !!item.productType;
      });
      if (!validItem) {
        this.sendErrorsAndResetCheckoutState([ERRORS.MISSING_PRODUCT_TYPE_FAILURE]);
        return null;
      }
      return validItem.productType;
    }

    /**
     * Sends checkout errors to host and resets checkout state.
     * @errors checkout errors
     * @extra any extra user information to include
     */
  }, {
    key: "sendErrorsAndResetCheckoutState",
    value: function sendErrorsAndResetCheckoutState(errors, extra) {
      // NewRelic - start
      sendNewRelicMessage(ORDER_PLACEMENT_FAILED, {
        errors: "".concat(JSON.stringify(errors)).concat(extra !== null && extra !== void 0 ? extra : '')
      });
      // NewRelic - end

      var messageId = JSON.stringify(errors[0].code);
      // Jest is not able to cover callback line :sigh
      sendRioEvent({
        info: errors[0].message,
        message_detail: getMopError(messageId).message_detail,
        message_id: messageId,
        specType: SpecType.NOTIFICATION,
        subType: SubType.ERROR,
        callback: function callback(logObj) {
          return fireLogEvent(logObj, Namespace.DROP_IN_PAYMENTS);
        },
        namespace: this.state.config.rioNamespace
      });
      this.dispatch(showMessage({
        text: ERRORS.GENERIC_FAILURE_ERROR.message,
        messageType: MessageType.ERROR
      }));
      this.callbackErrorsToHost(errors, DropInPaymentsCommandNames.PLACE_ORDER);
      this.dispatch(saveCartInfo({
        isCheckoutPending: false
      }));
      this.dispatch(saveUiConfigs({
        showUpiProcessing: false
      }));
    }

    //TODO: we need to come back to this logic, right now we receive a zip code of 11111 from MOPs created
    //without a zip code. This can happen for countries without zip code or countries where zip codes are optional.
    //The consequence of this, is that this flag will effectively always be set to true. This could cause problems down
    //the road in the new backend checkout architecture if BE wants to perform more naunced additional address validation.
    /**
     * Given zip collection flag, determines if the given country requires address validation
     * @param countryCode country on user's method of payment
     * @param zipCode zipcode on user's method of payment
     */
  }, {
    key: "shouldPerformAdditionalAddressValidation",
    value: function shouldPerformAdditionalAddressValidation(countryCode, zipCode) {
      return countryCode === 'US' || !!zipCode;
    }
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/InitializeUpiCheckoutCommand.js
// module id = 4698
// module chunks = 11